module.exports = __webpack_public_path__ + "static/media/karachi-r3.9cc739fe.svg";